/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component, Fragment } from 'react'

import Slider from 'react-slick'

import _ from 'lodash'

import Layout from '@Layout/ECFront'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'
import getFormStatus         from '@/Form/Functions/getFormStatus'

import HolidaysMessage from '@/HolidaysMessage'
import FloatingCard    from '@/FloatingCard'

import GMap from '@/Maps/GMap'

import InstagramIcon from '@/Icons/Instagram'
import LinkedinIcon  from '@/Icons/Linkedin'

import FrontCustomQuote from '@/CustomQuote/FrontCustomQuote'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'

const { app, qwest } = window;

export default class FrontPartnerPage extends Component
{
	state =
	{
		partner: { },
		references: [],
		loading: false
	};

	componentDidUpdate ()
	{
		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		let filter_query =
		{
			id: id
		};

		let tabs =
		[
			{ name: 'infos', label: 'Présentation' },
			{ name: 'places', label: 'Localisation' },
			{ name: 'images', label: 'Images' },
			{ name: 'contact', label: 'Contact' },
			{ name: 'custom_quote', label: 'Demande de devis' }
		];

		component.setState(
		{
			loading: true,
			active_tab: 'infos',
			tabs: tabs
		});

		qwest.post('/CMS/getAll',
		{
			model: 'partner',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			let partner = response.data[0];

			if (Array.isArray(partner.custom_quotes))
			{
				partner.custom_quotes = partner.custom_quotes
				.map(function (id)
				{
					let quote = (response.references
					.find(data => data.model === 'customquote') || { data: [] })
					.data.find(quote => quote.id === id);

					return quote ? quote : id;
				});
			}

			component.setState(
			{
				partner: response.data[0],
				references: response.references || [],
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.readNewPartnerNotification();
	}

	readNewPartnerNotification = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		qwest.post('/notifications/read',
		{
			patterns: ['new_partner_' + id]
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});

		qwest.post('/notifications/read',
		{
			patterns: ['updated_partner_' + id]
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	render ()
	{
		const component = this, props = this.props, partner = component.state.partner;

		const state = this.state;

		if ([true, 'true'].includes(partner.disabled))
		{
			const output =
			(
				<Layout page_title={ partner.name || 'Partenaire' }
					history={ props.history }>

					<div className="page-content c-model c-model--partner
						u-margin-top-0">

						<HolidaysMessage />

						{
							getFormStatus(
							{
								error: 'Ce partenaire n\'est plus disponible.'
							})
						}

					</div>

				</Layout>
			);

			return output;
		}

		let loader;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />;
		}

		let category = app.getReferedValue(
		{
			model: 'category',
			seek: 'name',
			references: component.state.references,
			id: partner.category
		});

		if (category)
		{
			category =
			(
				<div className="c-model__themes">
					<div className="c-model__theme">
						{ category }
					</div>
				</div>
			);
		}

		let images = (partner.images || []).map(function (data, index)
		{
			let output =
			(
				<div key={ data.url }>
					<Image className="c-model__carousel-image" src={ data.url } />
				</div>
			);

			return output;
		});

		const slider_settings =
		{
			dots: true,
			infinite: false,
			speed: 320,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			useCSS: true,
			breakpoint: 100,
			draggable: true
		};

		let slider;

		if (images.length)
		{
			slider =
			(
				<div className="c-model__images">
					<Slider { ...slider_settings }>
						{ images }
					</Slider>
				</div>
			);
		}

		if (component.state.loading === false)
		{
			component.gmap_rdy = true;
		}

		let google_map, place_label = '', places;

		if (partner.address_1)
		{
			let is_line_2_first = false;

			if (typeof partner.address_2 === 'string')
			{
				let line_2 = partner.address_2;

				is_line_2_first = ['Zone', 'ZI', 'ZA', 'Espace']
				.find(function (str)
				{
					return line_2.toLowerCase().indexOf(str.toLowerCase()) !== -1;
				});
			}

			if (is_line_2_first && partner.address_2)
			{
				place_label += partner.address_2 + ', ';
			}

			place_label += partner.address_1;

			if (!is_line_2_first && partner.address_2)
			{
				place_label += ', ' + partner.address_2;
			}

			place_label += partner.zip_code ? ', ' + partner.zip_code : '';

			if (!partner.zip_code) place_label += ',';

			place_label += partner.city ? ' ' + partner.city : '';

			places =
			(
				<div className="c-model__places">
					<svg className="o-svg-icon o-svg-icon--tracker c-model__places-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-tracker" />
					</svg>
					{ place_label }
				</div>
			);

			if (component.gmap_rdy === true)
			{
				let address =
				{
					line_1: partner.address_1,
					line_2: partner.address_2,
					zip_code: partner.zip_code,
					city: partner.city,
					label: place_label
				};

				const pins = [partner].map(function (partner)
				{
					let { lat, lng } = (partner.coordinates || { });

					if (lng !== undefined && lat !== undefined)
					{
						lat = Number(lat);
						lng = Number(lng);

						if (isNaN(lat) || isNaN(lng)) return;

						return { position: { lat, lng }, name: partner.name };
					}

					if (!(partner.geocoding || [])[0]) return;

					[lat, lng] = partner.geocoding[0].geometry.location
					.replace('(', '').replace(')', '')
					.split(', ');

					lat = Number(lat);
					lng = Number(lng);

					if (isNaN(lat) || isNaN(lng)) return;

					const data =
					{
						position: { lat: lat, lng: lng },
						name: partner.name
					};

					return data;
				})
				.filter(data => data && data.position);

				google_map =
				(
					<GMap className="c-model__gmap" address={ address }
						pins={ pins }
					/>
				);
			}
		}

		let localisation;

		if (places)
		{
			localisation =
			(
				<>
					<div className="c-subtitle u-margin-top-0">
						<h2 className="c-subtitle__txt">
							Où trouver ce partenaire&nbsp;?
						</h2>
					</div>

					<div className="c-model__map">

						{ places }

						{ google_map }

					</div>
				</>
			);
		}

		let tabs = state.tabs
		.filter(function (tab_infos, key)
		{
			if (tab_infos.name === 'places')
			{
				if (!places) return false;
			}
			else if (tab_infos.name === 'images')
			{
				if (!slider) return false;
			}
			else if (tab_infos.name === 'custom_quote')
			{
				if (!Array.isArray(partner.custom_quotes) || !partner.custom_quotes[0])
				{
					return false;
				}
			}

			return true;
		})
		.map(function (tab_infos, key)
		{
			let output =
			(
				<button type="button" key={ key } onClick={ function (e)
					{ component.setState({ active_tab: tab_infos.name }) } }
					className={ 'c-tab' + (state.active_tab === tab_infos.name ?
					' c-tab--active' : '') }>

					<div className="c-tab__label">
						{ tab_infos.label }
					</div>

				</button>
			);

			return output;
		});

		let show_your_card;

		if ([true, 'true'].includes(partner.online_access) === false)
		{
			show_your_card =
			(
				<div className="c-model__infos-area u-margin-top-20">
					<svg className="o-svg-icon o-svg-icon--synergies_card c-model__places-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-synergies_card" />
					</svg>
					Sur présentation de votre carte Synergies
				</div>
			);
		}

		let content;

		if (state.active_tab === 'infos')
		{
			let discount_infos = (partner.discount_infos || '')
			.split('rel="noopener noreferrer"')
			.join('')
			.split('<p><br></p>').join('');

			let informations = (partner.informations || '')
			.split('rel="noopener noreferrer"')
			.join('')
			.split('<p><br></p>').join('');

			let online_infos = (partner.online_access_infos || '')
			.split('rel="noopener noreferrer"')
			.join('')
			.split('<p><br></p>').join('');

			let online_access_link;

			if (discount_infos.length)
			{
				discount_infos =
				(
					<>
						<div className="c-subtitle">
							Remise &amp; avantages
						</div>

						{ show_your_card }

						<div className="c-model__description
							c-model__description-highlighted"
							dangerouslySetInnerHTML={ { __html: discount_infos } }
						/>
					</>
				);
			}

			if (informations.length)
			{
				informations =
				(
					<>
						<div className={ 'c-subtitle' + (discount_infos ?
							' u-margin-top-20' : '')  }>
							Informations
						</div>

						<div className="c-model__description"
							dangerouslySetInnerHTML= { { __html: informations } }>
						</div>
					</>
				);
			}

			if (online_infos.length)
			{
				online_infos =
				(
					<>
						<div className={ 'c-subtitle' + (discount_infos ?
							' u-margin-top-20' : '')  }>
							Accès en ligne
						</div>

						<div className="c-model__description"
							dangerouslySetInnerHTML={ { __html: online_infos } }
						/>
					</>
				);
			}

			if (partner.online_access_url && partner.online_access_url.length)
			{
				let url = partner.online_access_url;

				if (url.indexOf('http') === -1)
				{
					url = 'http://' + url;
				}

				online_access_link =
				(
					<div className="u-text-center u-margin-top-20 u-margin-bottom-20">
						<a href={ url } target="_blank"
							className="c-btn c-btn--primary c-btn--extra">
							Accéder à l'offre
						</a>
					</div>
				);
			}

			let place;

			if (place_label)
			{
				place =
				(
					<div className="c-model__places u-margin-bottom-20">
						<svg className="o-svg-icon o-svg-icon--tracker c-model__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker" />
						</svg>
						{ place_label }
					</div>
				);
			}

			let pdf_files = [];

			if (Array.isArray(partner.pdfs))
			{
				pdf_files = (partner.pdfs || [])
				.filter(data => Boolean(data))
				.map(function (file, i)
				{
					let output =
					(
						<div className={ 'u-full-width u-margin-top-' +
							(i === 0 ? '20' : '10') } key={ i }>
							<a href={ encodeURI(file.url) } type="application/pdf"
								target="_blank" rel="noreferrer">
								{ file.filename }
							</a>
						</div>
					);

					return output;
				});
			}

			let pdf_files_title;

			if (pdf_files.length > 0)
			{
				pdf_files_title =
				(
					<div className="c-subtitle u-margin-top-30">
						<div className="c-subtitle__txt">
							{
								'Document' +
								(pdf_files.length > 1 ? 's' : '') +
								' à télécharger'
							}
						</div>
					</div>
				);
			}

			content =
			(
				<div className="c-model__body">

					<div className="o-grid">

						<div className="o-grid__item-7">

							<div className="c-subtitle u-margin-bottom-20">
								<div className="c-subtitle__txt">
									{ partner.name }
								</div>
							</div>

							{ category }

							{ place }

							{ discount_infos }

							{ informations }

							{ online_infos }

							{ online_access_link }

						</div>

						<div className="o-grid__item-5">
							{ images[0] }
						</div>

						{ pdf_files_title }

						{ pdf_files }

					</div>
				</div>
			);
		}
		else if (state.active_tab === 'places')
		{
			content =
			(
				<div className="c-model__body">
					{ localisation }
				</div>
			);
		}
		else if (state.active_tab === 'images' && images.length)
		{
			content =
			(
				<div className="c-model__body">

					<div className="o-grid">

						<div className="o-grid__item-12">

							<div className="c-model__images">
								<Slider { ...slider_settings }>
									{ images }
								</Slider>
							</div>

						</div>

					</div>

				</div>
			);
		}
		else if (state.active_tab === 'contact')
		{
			let links =
			[
				partner.linkedin,
				partner.facebook,
				partner.website,
				partner.instagram
			];

			links = links
			.map(function (link, i)
			{
				if (!link) return link;

				if (link.indexOf('http') === -1)
				{
					if (i < 2)
					{
						link = 'https://' + link;
					}
					else
					{
						link = 'http://' + link;
					}
				}
				else if (link.indexOf('https') === -1 && i < 2)
				{
					link = link.replace('http', 'https');
				}

				return link;
			});

			let linkedin = links[0], facebook = links[1], website = links[2];
			let instagram = links[3];

			let email   = partner.email, phone = partner.phone;

			if (linkedin)
			{
				linkedin =
				(
					<a className="c-model__social" href={ linkedin } target="_blank"
						rel="noreferrer">
						<LinkedinIcon className="o-svg-icon o-svg-icon--linkedin		c-model__social-icon"
						/>
					</a>
				);
			}

			if (facebook)
			{
				facebook =
				(
					<a className="c-model__social" href={ facebook } target="_blank"
						rel="noreferrer">
						<svg className="o-svg-icon o-svg-icon--facebook c-model__social-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-facebook" />
						</svg>
					</a>
				);
			}

			if (instagram)
			{
				instagram =
				(
					<a className="c-model__social" href={ instagram } target="_blank"
						rel="noreferrer">
						<InstagramIcon className="o-svg-icon o-svg-icon--instagram		c-model__social-icon"
						/>
					</a>
				);
			}

			if (website)
			{
				website =
				(
					<a className="c-model__social" href={ website } target="_blank">
						<svg className="o-svg-icon o-svg-icon--website c-model__social-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-website" />
						</svg>

						<div className="c-model__social-text">
							Site web&nbsp;:
							{
								' ' +
								website
								.replace('http://', '')
								.replace('https://', '')
								.replace('www.', '')
							}
						</div>
					</a>
				);
			}

			if (email)
			{
				email =
				(
					<a className="c-model__social" href={ 'mailto:' + email }
						target="_blank" rel="noreferrer">
						<svg className="o-svg-icon o-svg-icon--mail c-model__social-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-mail" />
						</svg>

						<div className="c-model__social-text">
							Par e-mail&nbsp;:
							{
								' ' +
								email
								.replace('http://', '')
								.replace('https://', '')
								.replace('www.', '')
							}
						</div>
					</a>
				);
			}

			if (phone)
			{
				phone =
				(
					<a className="c-model__social" href={ 'tel:' + email }>
						<svg className="o-svg-icon o-svg-icon--phone c-model__social-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-phone" />
						</svg>

						<div className="c-model__social-text">
							Par téléphone&nbsp;:
							{
								' ' + app.getSpacedPhoneNumber(phone)
							}
						</div>
					</a>
				);
			}

			let place;

			if (place_label)
			{
				place =
				(
					<div className="c-model__social-media u-margin-bottom-10">
						<svg className="o-svg-icon o-svg-icon--tracker c-model__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker" />
						</svg>
						{ place_label }
					</div>
				);
			}

			content =
			(
				<div className="c-model__body">

					<div className="c-subtitle u-margin-top-0 u-margin-bottom-20">
						<h2 className="c-subtitle__txt">
							Contacter ou suivre ce partenaire
						</h2>
					</div>

					{ place }

					<div className="c-model__social-media">
						{ website }
					</div>

					<div className="c-model__social-media">
						{ email }
					</div>

					<div className="c-model__social-media">
						{ phone }
					</div>

					<div className="c-model__social-media">
						<div className="u-margin-right-10">
							Réseaux sociaux&nbsp;:
						</div>
						{ linkedin }
						{ facebook }
						{ instagram }
					</div>

				</div>
			);
		}
		else if (state.active_tab === 'custom_quote')
		{
			content = partner.custom_quotes.map(function (quote)
			{
				let output =
				(
					<Fragment key={ quote.id }>

						<div className="c-subtitle u-margin-bottom-20">
							<div className="c-subtitle__txt">
								{ quote.title || 'Demande de devis' }
							</div>
						</div>

						<FrontCustomQuote elements={ quote.elements } quote={ quote } />

					</Fragment>
				);

				return output;
			});

			content =
			(
				<div className="c-model__body">
					{ content }
				</div>
			);
		}

		let output =
		(
			<Layout page_title={ partner.name || 'Partenaire' }
				history={ props.history }>

				<div className="page-content c-model c-model--partner u-margin-top-15">

					<HolidaysMessage />

					<div className="c-model__content-wrapper">

						<div className="c-model__tabs">{ tabs }</div>

						<div className="c-model__content">
							{ content }
						</div>

						{ loader }

					</div>

				</div>

				<FloatingCard />

			</Layout>
		);

		return output;
	}
}
